import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAutomationTemplateStepNoActionCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.INoActionAutomationStep) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			templateId,
			step,
			beforeId,
			impersonationContext,
		}: {
			templateId: string;
			step: Api.INoActionAutomationStep;
			beforeId?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.INoActionAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/NoAction`,
					queryParams: beforeId ? { beforeId } : undefined,
					impersonationContext,
				}),
				'POST',
				step
			);
		},
		onError,
		onSuccess,
	});
}
